import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .use(Backend)
  .init({
    debug: false,
    fallbackLng: "en",
    returnObjects: true,
    ns: ["common", "notifications", "awards", "roles", "badges"], // ✅ Register multiple namespaces
    defaultNS: "common",
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json', // ✅ Load different namespaces dynamically
    },
    interpolation: {
      escapeValue: false, // React already escapes values by default
    },
  });

export default i18n;
